import React, { useEffect } from 'react';

// This lays out the main page, including the header (navbar), footer, and everything in between
// All contents are in terms of components, with Main as the mother of components

function PDFReader(props) {
    const { pdf } = props;

    useEffect(() => {
        window.location.replace(pdf);
    }, []);

    return <div style={{ margin: 100 }}>Loading...</div>;
}

export default PDFReader;